<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberEntry/edit?id=' + $route.query.member_id)" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-6 text-right">
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="submitData">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PT No Show</label>
                </b-col>
                <b-col sm="5">
                  <b-form-input v-model="editData.pt_no_show" name="pt_no_show" v-validate="'required|numeric'" type="text" v-on:input="ptNoShowChange"></b-form-input>
                  <span class="error">{{ errors.first('pt_no_show') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PT No Show Email</label>
                </b-col>
                <b-col sm="5">
                  <b-form-input disabled v-model="editData.pt_noshow_alert1_email_send" name="pt_noshow_alert1_email_send" v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('pt_noshow_alert1_email_send') }}</span>
                </b-col>
              </b-row>

              <div class="text-left mb-20">
                <!-- <button type="submit" class="btn-primary" :disabled="permission()">Submit</button> -->
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
            <hr>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'addPtSession',
  components: {
    'app-pagination': Pagination
  },
  data: function () {
    return {
      editData: {
        pt_no_show: 0,
        pt_noshow_alert1_email_send: 0
      }
    }
  },
  methods: {
    permission() {
      if (this.$route.query.member_id == 210) {
        return false
      } else {
        return true
      }
    },
    ptNoShowChange(ev) {
      // console.log(ev)
      this.editData.pt_noshow_alert1_email_send = ev
    },
    submitData () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.put('fitness/v1/member/data_entry/table/member/banned/detail/' + this.$route.query.id, this.editData).then(response => {
            // console.log('test', response)
            this.$router.push('/memberEntry/edit?id=' + this.$route.query.member_id)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      axios.get('fitness/v1/member/data_entry/table/member/banned/detail/' + this.$route.query.id).then(response => {
        // console.log(response.data.data)
        this.editData.pt_no_show = response.data.data.pt_no_show
        this.editData.pt_noshow_alert1_email_send = response.data.data.pt_noshow_alert1_email_send
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
